<template>
  <div class="searchable-grid global__fade-in-up">
    <div class="searchable-grid__top">
      <slot name="top"></slot>
      <div class="searchable-grid__search-form dont-print">
        <div class="searchable-grid__search-form-inner">
          <input
            type="text"
            ref="input"
            placeholder="Search"
            class="searchable-grid__search-form-input"
            @input="filterGrid"
            required
          />
          <button
            @click="filterGrid"
            class="searchble-grid__search-form-submit"
            aria-label="Submit search"
          >
            <slot name="search">
              <img src="/images/Search.svg" alt="" />
            </slot>
          </button>
        </div>
      </div>
    </div>

    <ul class="school-grid__grid" ref="cards">
      <slot></slot>
    </ul>
  </div>
</template>

<script>
import Fuse from 'fuse.js'
import jQuery from 'jquery'

export default {
  mounted() {
    this.cards = Array.from(this.$refs.cards.children)
    this.titles = []
    for (var i = 0; i < this.cards.length; ++i) {
      this.titles.push({
        title: this.cards[i].dataset.title,
        index: i,
      })
    }
    // threshold: 0.0 requires exact match, 1.0 will match to anything
    this.fuse = new Fuse(this.titles, { keys: ['title'], threshold: 0.3 })
  },
  methods: {
    filterGrid() {
      // show all when search field is empty
      if (this.$refs.input.value == '') {
        this.cards.forEach(function(card) {
          jQuery(card).fadeIn()
        })
        return
      }
      // only show cards that match fuzzy search
      var results = this.fuse.search(this.$refs.input.value)
      this.cards.forEach(function(card) {
        /* results is an array like
           [
             {
               item: {
                 title: ...,
                 index: ...,
               },
             },
           ]
        */
        // check if results contain this card's title
        if (results.some(e => e.item.title === card.dataset.title)) {
          jQuery(card).fadeIn()
        } else {
          jQuery(card).fadeOut()
        }
      })
    },
  },
}
</script>
